export default __webpack_public_path__ + "static/blob9-893f45d69d821d6b168e2da8d50f58c6.svg";